import { TPannellumConfig } from '../../types/panellum';

const basePath = 'https://static.treedis.com/projects/havatzelet';

export const pannellumConfigHavatzelet: { [key: number]: TPannellumConfig } = {
  1: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 4576,
    },
    pitch: -2,
    yaw: 13,
    hotSpots: [
      // Building hotspots
      {
        pitch: 7.624356543998184,
        yaw: 7.3187094377568656,
        type: 'info',
        createTooltipArgs: { title: 'בניין 1', type: 'building' },
      },
      {
        pitch: 7.823728859384469,
        yaw: -5.35717249011293,
        type: 'info',
        createTooltipArgs: { title: 'בניין 2', type: 'building' },
      },
      // POI hotspots
      {
        pitch: -1.802407455659206,
        yaw: -22.623693254179216,
        type: 'info',
        createTooltipArgs: {
          title: 'צוקי ים',
          type: 'poi',
          cardDescription: 'שמורת טבע',
          cardImageSrc: `${basePath}/pano/tags/poi_3.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      {
        pitch: -2.848956805088376,
        yaw: -42.40390881671914,
        type: 'info',
        createTooltipArgs: {
          title: 'שושנת העמקים',
          type: 'poi',
          cardDescription: 'ישוב קהילתי',
          cardImageSrc: `${basePath}/pano/tags/poi_4.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      {
        pitch: -0.08929038202249456,
        yaw: 16.054922238711583,
        type: 'info',
        createTooltipArgs: {
          title: 'חבצלת השרון',
          type: 'poi',
          cardDescription: 'מושב בישראל',
          cardImageSrc: `${basePath}/pano/tags/poi_1.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      {
        pitch: -0.41507843732979777,
        yaw: 65.4720160138645,
        type: 'info',
        createTooltipArgs: {
          title: 'גן לאומי אביחיל',
          type: 'poi',
          cardDescription: 'שמורת טבע',
          cardImageSrc: `${basePath}/pano/tags/poi_5.webp`,
          transportation: { car: 5, walk: 20, bicycle: 10 },
        },
      },
      {
        pitch: 3.1457388133303414,
        yaw: -164.69053735633076,
        type: 'info',
        createTooltipArgs: {
          title: 'נתניה',
          type: 'poi',
          cardDescription: 'עיר בישראל',
          cardImageSrc: `${basePath}/pano/tags/poi_2.webp`,
          transportation: { car: 20, walk: 120, bicycle: 60 },
        },
      },
      // Scene hotspot
      {
        pitch: 16.24506961705329,
        yaw: 6.632418023301057,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          type: 'scene',
          sceneId: 2,
          imgSrc: `${basePath}/pano/tags/scene_2.webp`,
        },
      },
    ],
  },
  2: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 4576,
    },
    pitch: 0,
    yaw: 0,
    hotSpots: [
      // Building hotspots
      {
        pitch: 9.651733377287846,
        yaw: -10.024184707688278,
        type: 'info',
        createTooltipArgs: { title: 'בניין 1', type: 'building' },
      },
      {
        pitch: 11.12020351603416,
        yaw: 2.5401856700993903,
        type: 'info',
        createTooltipArgs: { title: 'בניין 2', type: 'building' },
      },
      // POI hotspots
      {
        pitch: -6.434308913897013,
        yaw: -117.1470593696796,
        type: 'info',
        createTooltipArgs: {
          title: 'צוקי ים',
          type: 'poi',
          cardDescription: 'שמורת טבע',
          cardImageSrc: `${basePath}/pano/tags/poi_3.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      {
        pitch: 0.4799547986573858,
        yaw: 78.46019317353853,
        type: 'info',
        createTooltipArgs: {
          title: 'נתניה',
          type: 'poi',
          cardDescription: 'עיר בישראל',
          cardImageSrc: `${basePath}/pano/tags/poi_2.webp`,
          transportation: { car: 20, walk: 120, bicycle: 60 },
        },
      },
      {
        pitch: -18.45891618561297,
        yaw: -176.0091050693681,
        type: 'info',
        createTooltipArgs: {
          title: 'שושנת העמקים',
          type: 'poi',
          cardDescription: 'ישוב קהילתי',
          cardImageSrc: `${basePath}/pano/tags/poi_4.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      {
        pitch: -1.6892773676956478,
        yaw: -94.51521170895228,
        type: 'info',
        createTooltipArgs: {
          title: 'ישוב קהילתי צופי ים',
          type: 'poi',
          cardDescription: '',
          cardImageSrc: `${basePath}/pano/tags/poi_6.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      {
        pitch: -1.188762807670867,
        yaw: -34.985323743142146,
        type: 'info',
        createTooltipArgs: {
          title: 'גן לאומי אביחיל',
          type: 'poi',
          cardDescription: 'שמורת טבע',
          cardImageSrc: `${basePath}/pano/tags/poi_5.webp`,
          transportation: { car: 5, walk: 20, bicycle: 10 },
        },
      },
      {
        pitch: -0.8250605550084239,
        yaw: -70.60230563218624,
        type: 'info',
        createTooltipArgs: {
          title: 'חבצלת השרון',
          type: 'poi',
          cardDescription: 'מושב בישראל',
          cardImageSrc: `${basePath}/pano/tags/poi_1.webp`,
          transportation: { car: 5, walk: 15, bicycle: 10 },
        },
      },
      // Scene hotspot
      {
        pitch: 19.1061610856828,
        yaw: 2.9291441404203624,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          type: 'scene',
          sceneId: 1,
          imgSrc: `${basePath}/pano/tags/scene_1.webp`,
        },
      },
    ],
  },
};
